/* 日期类通用方法 */
import moment from "moment";
/* 获取最近日期区间 */
/* @days 间隔天数 */
export function getDateRange(days, type) {
    if (!type) {
        type = 'YYYY-MM-DD 00:00:00'
    }
    let beginDate = new Date();
    let endDate = new Date();
    beginDate.setDate(beginDate.getDate() - days)
    return [moment(beginDate).format(type), moment(endDate).format(type)]
}


/* 获取本月日期区间 */
export function getCurrentMonth() {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
    const result = [firstDay, today]
    return result;
}
export function getCurrentMonthFormat() {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
    const result = [dateFormat(firstDay, 'YYYY-MM-DD'), dateFormat(today, 'YYYY-MM-DD')]
    return result;
}
/* 获取今天日期区间 */
export function getTodayRange() {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
    const result = [firstDay, today]
    return result;
}

/* 获取今天日期区间 */
export function getTodayRangeFormat() {
    let date = []
    let start = moment().format('YYYY-MM-DD 00:00:00')
    let end = moment().format('YYYY-MM-DD HH:mm:ss')
    date.push(start)
    date.push(end)
    return date
}

/* 获取新时间 */
export function getNewDate(old, type, value) {
    var newDate = new Date();
    if (!old) {
        newDate = old;
    }
    switch (type) {
        case 'yyyy':
            newDate.setFullYear(newDate.getFullYear() + value)
            break;
        case 'MM':
            newDate.setMonth(newDate.getMonth() + value)
            break;
        case 'dd':
            newDate.setDate(newDate.getDate() + value)
            break;
        case 'mm':
            newDate.setMinutes(newDate.getMinutes() + value)
            break;
        case 'ss':
            newDate.getSeconds(newDate.getSeconds() + value)
            break;
        default:
            break;
    }
    return newDate;
}

export function momentFormat(date, formatter) {
    if (date)
        return moment(date).format(formatter)
    return date;
}

export function dateFormat(date) {
    if (date)
        return moment(date).format('YYYY-MM-DD')
    return date;
}

export function datetimeFormat(date) {
    if (date)
        return moment(date).format('YYYY-MM-DD HH:mm:ss')
    return date;
}

export function getDuration(value) {
    let time = moment.duration(value, 'seconds');
    const day = time.days();
    const hour = time.hours();
    const minutes = time.minutes();
    const seconds = time.seconds();
    return (day === 0 ? '' : day + '天') + (hour === 0 ? '' : hour + '小时') + (minutes === 0 ? '' : minutes + '分钟') + seconds + '秒'
}

export function getdatetimeforyearFormat(date) {
    if (date)
        return moment(date).format('YYYY')
    return date;
}

export function getdatetimeformonthFormat(date) {
    if (date)
        return moment(date).format('MM')
    return date;
}


// WEBPACK FOOTER //
// ./src/utils/dateUtils.js